import React from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'

import { NaughtyBits } from 'components/VRP/NaughtyBits'
import { getAllIlluminations } from 'actions/naughtyActions'
import { getIlluminationsForStats } from 'selectors/naughtySelectors'
import { getQueryValue } from 'selectors/pageStateSelectors'
import { addToPageState } from 'actions/pageStateActions'

import { getSelectedDateRange } from 'selectors/naughtySelectors'

const INTERACTIONS_POLL_INTERVAL = 10000

export class Interactions extends React.Component {
  constructor(...args) {
    super(...args)

    this.setupPoller = () => {
      let { getAllIlluminations, poll } = this.props
      getAllIlluminations && getAllIlluminations()

      if (!poll) return

      this.poller = setInterval(
        () => !this.props.isShowingQuote && getAllIlluminations(),
        INTERACTIONS_POLL_INTERVAL,
      )
    }
  }

  componentDidMount() {
    this.setupPoller()
  }

  componentWillUnmount() {
    clearInterval(this.setupPoller)
  }

  shouldComponentUpdate(prevProps) {
    return !isEqual(this.props, prevProps)
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.selectedDateRange, this.props.selectedDateRange)) {
      clearInterval(this.poller)
      this.setupPoller()
    }
  }

  render() {
    return <NaughtyBits {...this.props} showVehicle showAll />
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    events: getIlluminationsForStats(state),
    selectedDateRange: getSelectedDateRange(state),
    isShowingQuote: getQueryValue(state, 'quoteId'),
  }
}

export default connect(
  mapStateToProps,
  { getAllIlluminations, addToPageState },
)(Interactions)
